import {
  GET_MENU,
  GET_MENU_SUCCESS,
  GET_MENU_FAILURE,
  GET_BADGE_MENU,
  GET_BADGE_MENU_SUCCESS,
  GET_BADGE_MENU_FAILURE,
} from "actions/Menu/actionTypes";

const initialState = {
  getMenuLoading: false,
  objMenu: [],
  objBadgeMenu: {},
  menuLoaded: false,
};

const getMenu = (state, action) => ({
  ...state,
  getMenuLoading: true,
  menuLoaded: true,
});

const getMenuSuccess = (state, action) => {
  return {
    ...state,
    getMenuLoading: false,
    menuLoaded: true,
    objMenu: action.payload,
  };
};

const getMenuFailed = (state, action) => ({
  ...state,
  getMenuLoading: false,
  objMenu: [],
  menuLoaded: true,
});

const getBadgeMenu = (state, action) => ({
  ...state,
  getBadgeMenuLoading: true,
});

const getBadgeMenuSuccess = (state, action) => {
  return {
    ...state,
    getBadgeMenuLoading: false,
    objBadgeMenu: action.payload,
  };
};

const getBadgeMenuFailed = (state, action) => ({
  ...state,
  getBadgeMenuLoading: false,
  objBadgeMenu: {},
});
const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU:
      return getMenu(state, action);
    case GET_MENU_SUCCESS:
      return getMenuSuccess(state, action);
    case GET_MENU_FAILURE:
      return getMenuFailed(state, action);
    case GET_BADGE_MENU:
      return getBadgeMenu(state, action);
    case GET_BADGE_MENU_SUCCESS:
      return getBadgeMenuSuccess(state, action);
    case GET_BADGE_MENU_FAILURE:
      return getBadgeMenuFailed(state, action);
    default:
      return state;
  }
};

export default storeReducer;
